import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import StudentAttendanceContent from "../../containers/logged_user_components/user_exercise_test/user_adaptive_cps/components/user_attendance/StudentAttendanceContent";
import StudentDayMonthAttendanceContent from "./StudentDayMonthAttendanceContent";
import ParentHeader from "../parentHeader/ParentHeader";
import axios from "axios";
import uiActions from "../../redux/ui/action";

const UserAttendanceContent = (props) => {
  const { loginFromParent, rollNo } = props;

  const [isAnushaasan, setIsAnushaasan] = useState(null);

  useEffect(() => {
    const roll = rollNo;
    

    const getStudentProfile = async () => {
      try {
        const response = await axios.post(
          "https://learning.motion.ac.in/motioneducation/api/Parentdashboard",
          { roll_no: roll }
        );

        console.log("API Response:", response.data);

        if (response.data.status === 200) {
          const profileData = response.data.data;
          const isAnushaasanValue = response.data.is_anushaasan;

          setIsAnushaasan(isAnushaasanValue);

          console.log("received is_anushaasan:", isAnushaasanValue);
        }
      } catch (error) {
        console.error("Error fetching student profile:", error);
      }
    };

    getStudentProfile();
  }, [rollNo]);

  return (
    <div className="user-attendance-wrapper">
      {loginFromParent && <ParentHeader />}

      {isAnushaasan === null ? (
        <div>Loading...</div>
      ) : (
        <div>
          <div className="attendance-content-container">
            {!isAnushaasan ? (
              <StudentAttendanceContent />
            ) : (
              <StudentDayMonthAttendanceContent />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
  loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
  
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAttendanceContent);
